import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import type { Tag } from '#@/components/Tag';
import { useTranslations } from '#@/modules/translations';

import { StyledTag } from './Styles';

const PremiumBadge = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof Tag>, 'color' | 'gradient' | 'solidBackground'>
>((props, ref) => {
  const translations = useTranslations('subcontractorPremium');

  return (
    <StyledTag ref={ref} {...props}>
      {translations.premium}
    </StyledTag>
  );
});

PremiumBadge.displayName = 'PremiumBadge';

export default PremiumBadge;
